<template>
  <div class="p-3 border-b border-solid border-gray-300 cursor-pointer text-gray-600 hover:text-gray-900 relative"
    :class="{ selected, unread }"
    @click="$emit('click', contact)"
  >

    <template v-if="type == 'group'">
      {{ contact.title }}
      <font-awesome-icon :icon="['far', 'users-class']" class="ml-2"></font-awesome-icon>
    </template>
    <template v-else-if="contact.first_name">
      <div class="flex items-center justify-between" >
        <span>{{ contact.first_name }} {{ contact.last_name }} </span>
        <div width="w-48" v-if="!unread && type != 'unread_messages'">
          <div>
            <span @click.stop="toggleDropdown" class="p-2" style="margin-right: -8px;">
              <font-awesome-icon :icon="['far', 'ellipsis-vertical']" class="ml-2"></font-awesome-icon>
            </span>
          </div>
          <transition name="dropdown">
            <div v-if="isDropdownOpen" class="absolute z-50 rounded-md shadow-lg w-40 origin-top-right right-0">
              <ul class="p-2 rounded-md shadow-xs bg-white">
                <li class="text-gray-600" @click.stop="markUnread(contact)">Mark Unread</li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </template>
    <template v-else-if="contact.phone_number">
      <div class="flex items-center justify-between">
        <span class="flex-1">{{ contact.phone_number }} </span>
        <div width="w-48" v-if="!unread && type != 'unread_messages'">
          <div>
            <span @click.stop="toggleDropdown" class="p-2" style="margin-right: -8px;">
              <font-awesome-icon :icon="['far', 'ellipsis-vertical']" class="ml-2"></font-awesome-icon>
            </span>
          </div>
          <transition name="dropdown">
            <div v-if="isDropdownOpen" class="absolute z-50 rounded-md shadow-lg w-40 origin-top-right right-0">
              <ul class="p-2 rounded-md shadow-xs bg-white">
                <li class="text-gray-600" @click.stop="markUnread(contact)">Mark Unread</li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </template>
    <template v-else @click="$emit('click', contact)">
      Contact data missing
    </template>

  </div>
</template>


<script>

import { mapWritableState } from 'pinia';
import inboxStore from '../../Stores/inbox.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUsersClass, faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import axios from 'axios';
library.add(faUsersClass, faEllipsisVertical);

export default {
  name: 'MessagesContactLabel',
  props: ['contact', 'type'],
  emits: ['click'],
  data() {
    return {
      isDropdownOpen: false
    }
  },
  components: {
    // JetDropdown,
  },
  methods: {
    markUnread(contact) {
      axios.post(route('message.mark-unread', {
        contact: contact.tra_id
      })).then(() => {
        this.$inertia.visit(route('messages.inbox'))
      })
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    }
  },
  computed: {
    ...mapWritableState(inboxStore, ['activeContact', 'readContacts']),
    selected() {
      if (!this.activeContact) return false;

      return this.contact.tra_id == this.activeContact.tra_id;
    },
    unread() {
      if (!this.contact.has_notification) return false;
      return !_.some(this.readContacts, { tra_id: this.contact.tra_id });
    },

  },
  mounted() {
    document.addEventListener('click', this.closeOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeOutside);
  }
};

</script>

<style lang="scss" scoped>
.selected {
  @apply bg-blue-100 font-bold text-blue-500;
}

.unread {
  @apply font-bold;
}
.dropdown-enter-active, .dropdown-leave-active {
  transition: opacity 0.3s ease; /* Adjust timing and easing as needed */
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
}
</style>
